import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { DistrictSchoolService } from "../report-services/district-school.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

/* Converted Incidents
 * Uses:
 *      Start Date
 *      End Date
 *      Sort By (Action, Date, Homeroom, Infraction, Name)
 */

@Component({
	templateUrl: "./convertedincidents.component.html",
})
export class ConvertedIncidentsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		private schoolService: DistrictSchoolService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		startDate: new Date(),
		endDate: new Date(),
		SortBy: "Action",
	};

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	schoolList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	lstSortBy = [
		{
			SortByDesc: "Action",
		},
		{
			SortByDesc: "Date",
		},
		{
			SortByDesc: "Homeroom",
		},
		{
			SortByDesc: "Infraction",
		},
		{
			SortByDesc: "Name",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 370;
	subscription: any;

	ngOnInit() {
		// this.loadSchoolist()
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
	}

	private loadSchoolist() {
		var result = this.schoolService.loadDistrictSchoolList("", 0);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					// this.schoolList.unshift({
					//     SchoolID: 0,
					//     SchoolName: "All Schools"
					// })
					this.onSchoolChange(this.schoolList[0].SchoolID);
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	Print() {
		// if (!this.report.SchoolID) {
		//   this.errorMessage = "Select the School"
		//   return;
		// }

		var component = this;
		this.errorMessage = "";

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 370;
		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += moment(this.report.startDate).format("MM/DD/YYYY") + "|StartDate";
		strParam += "," + moment(this.report.endDate).format("MM/DD/YYYY") + "|EndDate";
		strParam += "," + this.report.SortBy + "|ORDERBY";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
